/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type BulkOperationResultDisplay_bulkOperationResult$ref = any;
export type ConversationMemberType = "BUYER" | "EXTERNAL" | "INTERNAL" | "SELLER" | "%future added value";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PartyRole = "BUYER" | "EXTERNAL" | "INTERNAL" | "LSP" | "SELLER" | "%future added value";
export type ShipmentQuoteRequestInput = {
    readonly buyerId: string;
    readonly itemPk?: string | null;
    readonly itemIds?: ReadonlyArray<string | null> | null;
    readonly dealerPk?: string | null;
    readonly message: string;
    readonly subject: string;
    readonly action?: string | null;
    readonly pageContext?: string | null;
    readonly transactionId?: string | null;
    readonly conversationId?: string | null;
    readonly city?: string | null;
    readonly state?: string | null;
    readonly country?: string | null;
    readonly zipCode?: string | null;
    readonly currencyConversionRateEventId?: string | null;
    readonly shippingAddressId?: string | null;
    readonly portfolioIds?: ReadonlyArray<string | null> | null;
    readonly conversationIds?: ReadonlyArray<string | null> | null;
    readonly clientMutationId?: string | null;
};
export type drsmRequestShipmentQuoteMutationVariables = {
    readonly input: ShipmentQuoteRequestInput;
    readonly userId: string;
    readonly conversationIds: ReadonlyArray<string | null>;
    readonly shouldFetchConversations: boolean;
};
export type drsmRequestShipmentQuoteMutationResponse = {
    readonly shipmentQuoteRequest: {
        readonly conversation: {
            readonly id: string;
            readonly messages: ReadonlyArray<{
                readonly textBody: string | null;
                readonly actionShippingQuoteRequested: boolean | null;
                readonly from: {
                    readonly userType: ConversationMemberType | null;
                } | null;
                readonly fromUserId: string | null;
                readonly fromDisplayName: string | null;
                readonly createdDate: string | null;
            } | null> | null;
            readonly transaction: {
                readonly serviceId: string | null;
                readonly isClosed: boolean | null;
                readonly isCanceled: boolean | null;
                readonly isConfirmed: boolean | null;
                readonly isNegotiable: boolean | null;
                readonly isOffPlatformOrder: boolean | null;
                readonly hasCompletedCheckout: boolean | null;
                readonly shipmentQuotes: ReadonlyArray<{
                    readonly status: string | null;
                } | null> | null;
                readonly shipment: {
                    readonly hasBeenShipped: boolean | null;
                    readonly shippingAddress: {
                        readonly city: string | null;
                        readonly state: string | null;
                        readonly zipCode: string | null;
                        readonly displayCountry: string | null;
                    } | null;
                    readonly shipmentTracking: {
                        readonly trackingNumber: string | null;
                        readonly trackingUrl: string | null;
                        readonly carrier: {
                            readonly name: string | null;
                        } | null;
                    } | null;
                } | null;
                readonly summary: {
                    readonly checkoutPaymentAuthorization: {
                        readonly isPendingApproval: boolean | null;
                    } | null;
                    readonly acceptedCommercialQuote: {
                        readonly isComplimentary: boolean | null;
                        readonly isCustom: boolean | null;
                        readonly isLocalPickup: boolean | null;
                        readonly handlingTimeDisplay: string | null;
                        readonly serviceMethod: {
                            readonly displayName: string | null;
                        } | null;
                        readonly totalAmount: {
                            readonly amount: number | null;
                            readonly convertedAmountList: ReadonlyArray<{
                                readonly currency: Currency | null;
                                readonly amount: number | null;
                            } | null> | null;
                        } | null;
                        readonly author: {
                            readonly role: PartyRole | null;
                        } | null;
                    } | null;
                } | null;
                readonly lastShipmentQuote: {
                    readonly isFromBuyer: boolean | null;
                    readonly isFromDealer: boolean | null;
                    readonly isNew: boolean | null;
                    readonly is1stdibsQuote: boolean | null;
                } | null;
            } | null;
        } | null;
        readonly conversations?: ReadonlyArray<{
            readonly item: {
                readonly serviceId: string | null;
            } | null;
            readonly originalSeller: {
                readonly displayName: string | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": BulkOperationResultDisplay_bulkOperationResult$ref;
    } | null;
};
export type drsmRequestShipmentQuoteMutation = {
    readonly response: drsmRequestShipmentQuoteMutationResponse;
    readonly variables: drsmRequestShipmentQuoteMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ShipmentQuoteRequestInput!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "conversationIds",
            "type": "[String]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFetchConversations",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "textBody",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "actionShippingQuoteRequested",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userType",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "fromUserId",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "fromDisplayName",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isClosed",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCanceled",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isConfirmed",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isNegotiable",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isOffPlatformOrder",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasCompletedCheckout",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasBeenShipped",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "zipCode",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayCountry",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "trackingNumber",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "trackingUrl",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isPendingApproval",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isComplimentary",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustom",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isLocalPickup",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "handlingTimeDisplay",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v31 = [
        (v30 /*: any*/)
    ], v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "totalAmount",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": [
            (v32 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "convertedAmountList",
                "storageKey": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                    },
                    (v32 /*: any*/)
                ]
            }
        ]
    } as any), v34 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "author",
        "storageKey": null,
        "args": null,
        "concreteType": "Party",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v35 = [
        ({
            "kind": "Literal",
            "name": "onlyCommercialQuotes",
            "value": true
        } as any),
        ({
            "kind": "Literal",
            "name": "onlyCustomQuotes",
            "value": true
        } as any)
    ], v36 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isFromBuyer",
        "args": null,
        "storageKey": null
    } as any), v37 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isFromDealer",
        "args": null,
        "storageKey": null
    } as any), v38 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isNew",
        "args": null,
        "storageKey": null
    } as any), v39 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is1stdibsQuote",
        "args": null,
        "storageKey": null
    } as any), v40 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v41 = [
        ({
            "kind": "Variable",
            "name": "conversationIds",
            "variableName": "conversationIds"
        } as any),
        (v40 /*: any*/)
    ], v42 = [
        (v30 /*: any*/),
        (v2 /*: any*/)
    ], v43 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v44 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "projects",
        "storageKey": null,
        "args": [
            (v40 /*: any*/)
        ],
        "concreteType": "Project",
        "plural": true,
        "selections": [
            (v9 /*: any*/),
            (v24 /*: any*/),
            (v2 /*: any*/)
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "drsmRequestShipmentQuoteMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuoteRequest",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ShipmentQuoteRequestPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "conversation",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Conversation",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "messages",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Message",
                                    "plural": true,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "from",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConversationMember",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/)
                                            ]
                                        },
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transaction",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Transaction",
                                    "plural": false,
                                    "selections": [
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuotes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": true,
                                            "selections": [
                                                (v16 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipment",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "plural": false,
                                            "selections": [
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shippingAddress",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "plural": false,
                                                    "selections": [
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shipmentTracking",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentTracking",
                                                    "plural": false,
                                                    "selections": [
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "carrier",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Carrier",
                                                            "plural": false,
                                                            "selections": [
                                                                (v24 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "summary",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionSummaryObject",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "checkoutPaymentAuthorization",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PaymentAuthorization",
                                                    "plural": false,
                                                    "selections": [
                                                        (v25 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "acceptedCommercialQuote",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentQuote",
                                                    "plural": false,
                                                    "selections": [
                                                        (v26 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "serviceMethod",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ShipmentServiceMethod",
                                                            "plural": false,
                                                            "selections": (v31 /*: any*/)
                                                        },
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "lastShipmentQuote",
                                            "storageKey": "lastShipmentQuote(onlyCommercialQuotes:true,onlyCustomQuotes:true)",
                                            "args": (v35 /*: any*/),
                                            "concreteType": "ShipmentQuote",
                                            "plural": false,
                                            "selections": [
                                                (v36 /*: any*/),
                                                (v37 /*: any*/),
                                                (v38 /*: any*/),
                                                (v39 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "BulkOperationResultDisplay_bulkOperationResult",
                            "args": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFetchConversations",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conversations",
                                    "storageKey": null,
                                    "args": (v41 /*: any*/),
                                    "concreteType": "Conversation",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "originalSeller",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConversationMember",
                                            "plural": false,
                                            "selections": (v31 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "drsmRequestShipmentQuoteMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipmentQuoteRequest",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ShipmentQuoteRequestPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "conversation",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Conversation",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "messages",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Message",
                                    "plural": true,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "from",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConversationMember",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        (v6 /*: any*/),
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transaction",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Transaction",
                                    "plural": false,
                                    "selections": [
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipmentQuotes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ShipmentQuote",
                                            "plural": true,
                                            "selections": [
                                                (v16 /*: any*/),
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shipment",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Shipment",
                                            "plural": false,
                                            "selections": [
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shippingAddress",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "plural": false,
                                                    "selections": [
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "shipmentTracking",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentTracking",
                                                    "plural": false,
                                                    "selections": [
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "carrier",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Carrier",
                                                            "plural": false,
                                                            "selections": [
                                                                (v24 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "summary",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionSummaryObject",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "checkoutPaymentAuthorization",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PaymentAuthorization",
                                                    "plural": false,
                                                    "selections": [
                                                        (v25 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "acceptedCommercialQuote",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ShipmentQuote",
                                                    "plural": false,
                                                    "selections": [
                                                        (v26 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "serviceMethod",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ShipmentServiceMethod",
                                                            "plural": false,
                                                            "selections": (v42 /*: any*/)
                                                        },
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "lastShipmentQuote",
                                            "storageKey": "lastShipmentQuote(onlyCommercialQuotes:true,onlyCustomQuotes:true)",
                                            "args": (v35 /*: any*/),
                                            "concreteType": "ShipmentQuote",
                                            "plural": false,
                                            "selections": [
                                                (v36 /*: any*/),
                                                (v37 /*: any*/),
                                                (v38 /*: any*/),
                                                (v39 /*: any*/),
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "itemsSucceeded",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": true,
                            "selections": [
                                (v43 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasRequestedHoldForBuyer",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "buyerId",
                                            "variableName": "userId"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v44 /*: any*/),
                                (v2 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "itemsFailed",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": true,
                            "selections": [
                                (v43 /*: any*/),
                                (v9 /*: any*/),
                                (v44 /*: any*/),
                                (v2 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "failureCodes",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemRequestFailureCode",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "itemId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "failureCode",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFetchConversations",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conversations",
                                    "storageKey": null,
                                    "args": (v41 /*: any*/),
                                    "concreteType": "Conversation",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "item",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Item",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v2 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "originalSeller",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConversationMember",
                                            "plural": false,
                                            "selections": (v42 /*: any*/)
                                        },
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "drsmRequestShipmentQuoteMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/drsmRequestShipmentQuoteMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f663db818aa69e12f9ddd1a22c5f2fed';
export default node;
